export class DeleteFleetConfigurationResponse {
    fleetId?: string;
}